export const menu = {
  home: "Inicio",
  corporateIdentity: "Identidad Corporativa",
  pages: "Páginas",
  aboutUs: "Sobre Nosotros",
  faq: "Preguntas Frecuentes",
  error404: "Error 404",
  services: "Servicios",
  maritimeLaw: "Derecho Marítimo",
  taxLaw: "Derecho Tributario",
  customsLaw: "Derecho Aduanero",
  commercialLaw: "Derecho Comercial",
  insurance: "Seguros",
  administrativeProcesses: "Procesos Administrativos",
  stsOperations: "Operaciones STS",
  contact: "Contacto",
  language: "Idioma",
  spanish: "Español",
  english: "Inglés",
  chinese: "Chino",
  contactUs: "Contáctenos",
  ofac: "OFAC"
};
